import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${string}/revisions`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/revisions`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/revisions`;
